import React from 'react';
import { Link } from 'react-router-dom';

import pluralize from 'rebook/apps/utils/text/pluralize';
import TagLabel from 'rebook/apps/base/components/TagLabel';

import styles from './style.scss';


const SearchResultsCount = (props) => {
  const {
    bookList,
    booksCount,
    audioBookList,
    audioBooksCount,
    authorsCount,
    authorsList,
    seriesList,
    genresThemesCount,
    genresList,
    nichesList,
    tagsList,
    seriesCount,
    booksetList,
    booksetsCount,
    rightholdersList,
    rightholdersCount,
    totalCount,
    query,
  } = props;

  return (
    <React.Fragment>
      <div className={styles.title}>
        {pluralize(totalCount, 'Найден', 'Найдено', 'Найдено')}&nbsp;
        {totalCount}
        &nbsp;
        {pluralize(totalCount, 'результат', 'результата', 'результатов')}
      </div>
      {booksCount > 0 && (
        <Link to={{
          pathname: `/search/books/`,
          state: { bookList, booksCount, query },
          search: `?q=${query}` }}>
          <TagLabel name={`${booksCount} ${pluralize(booksCount, 'книга', 'книги', 'книг')}`} />
        </Link>
      )}
      {audioBooksCount > 0 && (
        <Link to={{
          pathname: `/search/audiobooks/`,
          state: { audioBookList, audioBooksCount, query },
          search: `?q=${query}` }}>
          <TagLabel
            name={`${audioBooksCount} ${pluralize(audioBooksCount, 'аудиокнига', 'аудиокниги', 'аудиокниг')}`} />
        </Link>
      )}
      {authorsCount > 0 && (
        <Link to={{
          pathname: `/search/authors/`,
          state: { authorsList, authorsCount, query },
          search: `?q=${query}` }}>
          <TagLabel
            name={`${authorsCount} ${pluralize(authorsCount, 'автор', 'автора', 'авторов')}`} />
        </Link>
      )}
      { genresThemesCount > 0 && (
        <Link to={{
          pathname: `/search/genres-themes/`,
          state: { genresList, nichesList, tagsList, genresThemesCount, query },
          search: `?q=${query}` }}
        className="jest-genres-label">
          <TagLabel name={
            `${genresThemesCount} ${pluralize(genresThemesCount, 'жанр', 'жанра и темы', 'жанров и тем')}`
          } />
        </Link>
      )}
      {seriesCount > 0 && (
        <Link to={{
          pathname: `/search/series/`,
          state: { seriesList, seriesCount, query },
          search: `?q=${query}` }}>
          <TagLabel name={`${seriesCount} ${pluralize(seriesCount, 'серия', 'серии', 'серий')}`} />
        </Link>
      )}
      {booksetsCount > 0 && (
        <Link to={{
          pathname: `/search/booksets/`,
          state: { booksetList, booksetsCount, query },
          search: `?q=${query}` }}>
          <TagLabel name={`${booksetsCount} ${pluralize(booksetsCount, 'подборка', 'подборки', 'подборок')}`} />
        </Link>
      )}
      {rightholdersCount > 0 && (
        <Link to={{
          pathname: `/search/rightholders/`,
          state: { rightholdersList, rightholdersCount, query },
          search: `?q=${query}` }}>
          <TagLabel name={
            `${rightholdersCount} ${pluralize(rightholdersCount, 'издатель', 'издателя', 'издателей')}`
          } />
        </Link>
      )}
    </React.Fragment>
  );
};

export default SearchResultsCount;
